import styled from 'styled-components';

export const StyledUser = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 0.5rem;
  color: #fff;
  font-weight: 400;
`;
